import { Injectable, Output, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { RoutingService } from "src/app/services";
import { lastValueFrom } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private lookups = new Map<string, any>();
  private reportService = environment.reportService.url + environment.reportService.apiVersion;

  UserReportFeaturesLookupKey = "UserReportFeatures";
  ReportFiltersLookupKey = "ReportFiltersFeatures";

  constructor(private http: HttpClient) { }


  getUsersReportsList(reportType: string, sponsorName: string, portalId: number) {
    return new Promise<any[]>((resolve, reject) => {
      if (this.lookups.has(this.UserReportFeaturesLookupKey + '_' + reportType + '_' + portalId)) {
        resolve(this.lookups.get(this.UserReportFeaturesLookupKey + '_' + reportType + '_' + portalId));
      } else {
        lastValueFrom(this.http.get<any>(this.reportService + 'Report/' + reportType + '/' + sponsorName + '/' + portalId))
          .then((data: any) => {
            this.lookups.set(this.UserReportFeaturesLookupKey + '_' + reportType + '_' + portalId, data);
            resolve(data);
          },
            (err) => {
              reject(err);
            });
      }
    });

  }

  getFilterData(filterType: string, sponsorName: string, portalId: number, groupTypeName: string = "") {
    return new Promise<any[]>((resolve, reject) => {

      let lookupKey = `${this.ReportFiltersLookupKey}_${filterType}_${portalId}` + (groupTypeName == "" ? "" : `_${groupTypeName}`);
      if (this.lookups.has(lookupKey)) {
        resolve(this.lookups.get(lookupKey));
      } else {
        let url = groupTypeName == "" ? `Filter/${filterType}/${sponsorName}/${portalId}` : `Filter/${filterType}/${sponsorName}/${portalId}/${groupTypeName}`;
        lastValueFrom(this.http.get<any>(this.reportService + url))
          .then((data: any) => {
            this.lookups.set(lookupKey, data);
            resolve(data);
          },
            (err) => {
              reject(err);
            });
      }
    });

  }

  getFilterSusarData(filterType: string, sponsorName: string, portalId: number, susarMetaDataID: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.reportService + `Filter/${filterType}/${sponsorName}/${portalId}/${susarMetaDataID}`
      ))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );    
    });
  }

  getMetaDataIDByName(filterType: string, sponsorName: string, portalId: number, susarMetaDataName: string) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.reportService + `Filter/${filterType}/${sponsorName}/${portalId}/${susarMetaDataName}`
      ))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  getSusarFilterColumns(filterType: string, sponsorName: string, isFilter: number, susartypeIds: Array<number>) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.reportService + `Filter/${filterType}/${sponsorName}/${isFilter}`, susartypeIds
      ))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  getReport(parentFeature: string, reportName: string, reportGridOptions: any, isExport: boolean = false) {
    return new Promise<any>((resolve, reject) => {
      let url = isExport ? `${parentFeature}/Export${reportName}` : `${parentFeature}/${reportName}`;      
      lastValueFrom(this.http.post<any>(this.reportService + url, reportGridOptions))
        .then((data: any) => {
          resolve(data);
        },
          (err) => {
            reject(err);
          });
    });
  }

  getMetricsGuauge(sponsor: string, portalId: number, reportType: string) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.reportService + "MetricsReports/Metrics/" + sponsor + "/" + reportType + "/" + portalId
      ))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  getMetricsData(type: string, filters: any) {
    return new Promise<any>((resolve, reject) => {
      let url = `MetricsReports/Metrics/${type}/`;
      lastValueFrom(this.http.post(this.reportService + url, filters
      ))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  getEmailCampaignModal(sponsor: string, portalId: number, emailCampaignRequest: any) {
    return new Promise<any>((resolve, reject) => {
      let url = `MetricsReports/GetEmailCampaignModal/${sponsor}/${portalId}`;
      lastValueFrom(this.http.post(this.reportService + url, emailCampaignRequest
      ))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  scheduleEmailCampaign(sponsor: string, portalId: number, emailCampaignModel: any) {
    return new Promise<any>((resolve, reject) => {
      let url = `MetricsReports/ScheduleEmailCampaign/${sponsor}/${portalId}`;
      lastValueFrom(this.http.post(this.reportService + url, emailCampaignModel
      ))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }


  getEmailCampaignDataGrid(sponsor: string, portalId: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.reportService + "MetricsReports/EmailCampaign/" + sponsor + "/" + portalId))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  getEmailCampaignData(sponsor: string, portalId: number, mid: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.reportService + "MetricsReports/EmailCampaign/" + sponsor + "/" + portalId + "/" + mid))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  updateEmailCampaignStatus(sponsor: string, portalId: number, mid: number) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.reportService + "MetricsReports/ChangeEmailCampaignStatus/" + sponsor + "/" + portalId + "/" + mid))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  getComparisonMetricsData(filters: any, type: string) {
    return new Promise<any>((resolve, reject) => {
      let url = `MetricsReports/MetricsComparison/${type}/`;
      lastValueFrom(this.http.post(this.reportService + url, filters))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  getFilterDataBySponsor(filterType: string, sponsorName: string) {
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get(this.reportService + `Filter/${filterType}/${sponsorName}`
      ))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }

}
